import { ActivityDefinition } from './activity_definition';
export class Activity {
    objectType = 'Activity';
    id;
    definition;
    constructor(cfg = { objectType: 'Activity' }) {
        if (cfg.definition) {
            if (cfg.definition instanceof ActivityDefinition) {
                this.definition = cfg.definition;
            }
            else {
                this.definition = new ActivityDefinition(cfg.definition);
            }
        }
        this.id = cfg.id;
    }
    toString(lang = 'en-US') {
        let defString = '';
        if (this.definition) {
            defString = this.definition.toString(lang);
            if (defString !== '') {
                return defString;
            }
        }
        if (this.id) {
            return this.id;
        }
        return 'Activity: unidentified';
    }
    asVersion(version = '1.0.3') {
        const result = {
            id: this.id,
            objectType: this.objectType
        };
        if (this.definition) {
            result.definition = this.definition.asVersion(version);
        }
        return result;
    }
    static fromJSON(activityJSON) {
        const _activity = JSON.parse(activityJSON);
        return new Activity(_activity);
    }
}
